module.exports = __webpack_public_path__ + "img/bgr-catalog-theme-birthday.82c1afe9.svg";